import * as THREE from 'three';

class Room {
    private object3D: THREE.Object3D;
    private material: THREE.MeshBasicMaterial = new THREE.MeshBasicMaterial();
    private roomId: number;
    private static idCounter = 0;

    constructor(cornerPositions: { x: number, z: number }[], cornerEnd?: { x: number, z: number }) {
        this.roomId = Room.idCounter++;
        this.object3D = new THREE.Object3D();

        this.createFloor(cornerPositions, 0.5, 0.05);
    }

    private createFloor(cornerPositions: { x: number, z: number }[], height: number, wallThickness: number) {
        if (cornerPositions.length < 2) return;

        const vertices: number[] = [];
        const indices: number[] = [];
        const boxes: THREE.Box3[] = [];

        // Create walls between each pair of corner positions
        for (let i = 0; i < cornerPositions.length; i++) {
            const start = cornerPositions[i];
            const end = cornerPositions[(i + 1) % cornerPositions.length];

            // Define vertices for the wall segment
            const wallVertices = [
                start.x, 0, start.z,
                end.x, 0, end.z,
                end.x, height, end.z,
                start.x, height, start.z,
                start.x, 0, start.z - wallThickness,
                end.x, 0, end.z - wallThickness,
                end.x, height, end.z - wallThickness,
                start.x, height, start.z - wallThickness,
            ];

            // Define indices for the wall segment
            const offset = i * wallVertices.length / 3;
            const wallIndices = [
                offset, offset + 1, offset + 2, offset, offset + 2, offset + 3,
            ];

            vertices.push(...wallVertices);
            indices.push(...wallIndices);


            // Create a bounding box for this wall segment
            const wallBox = new THREE.Box3(
                new THREE.Vector3(Math.min(start.x, end.x), 0, Math.min(start.z, end.z)),
                new THREE.Vector3(Math.max(start.x, end.x), height, Math.max(start.z, end.z))
            );
            boxes.push(wallBox);
        }

        // Combine all bounding boxes into one if necessary
        const combinedBox = new THREE.Box3();
        boxes.forEach(box => combinedBox.union(box));


        // Create BufferGeometry and add vertices and indices
        const geometry = new THREE.BufferGeometry();
        geometry.setAttribute('position', new THREE.Float32BufferAttribute(vertices, 3));
        geometry.setIndex(indices);
        geometry.computeVertexNormals();

        // Create material and mesh
        const material = new THREE.MeshStandardMaterial({ color: "white", side: THREE.DoubleSide });

        const walls = new THREE.Mesh(geometry, material);
        walls.castShadow = true;
        walls.receiveShadow = true;

        this.object3D = walls;
    }

    public getObject3D() {
        return this.object3D;
    }

    public setColor(color: number) {
        this.object3D.children.forEach(child => {
            if (child instanceof THREE.Mesh && child !== this.object3D.children[0]) {
                (child.material as THREE.MeshBasicMaterial).color.setHex(color);
            }
        });
    }
}

export default Room;